function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.16 6.66L11.82 15H2.25C1.01 15 0 16 0 17.25v13.5C0 31.99 1 33 2.25 33h9.57l8.34 8.34a2.25 2.25 0 003.84-1.6V8.26c0-2.01-2.43-3-3.84-1.59zM43.28 24l4.28-4.28c.59-.59.59-1.55 0-2.14l-2.14-2.14c-.6-.59-1.55-.59-2.14 0L39 19.72l-4.28-4.28c-.59-.59-1.55-.59-2.14 0l-2.14 2.14a1.51 1.51 0 000 2.14L34.72 24l-4.28 4.28a1.51 1.51 0 000 2.14l2.14 2.14c.6.59 1.55.59 2.14 0L39 28.28l4.28 4.28c.59.59 1.55.59 2.14 0l2.14-2.14c.59-.6.59-1.55 0-2.14L43.28 24z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
})))));